import { useEffect, useState } from "react";
import { Lock, Unlock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Switch } from "./ui/switch";

export function NhpLockSettingCard() {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/nhp-lock").then((r) => setEnabled(r.data.enabled)).catch(() => setEnabled(true)); }, []);
  const toggle = async (v) => {
    setSaving(true);
    try {
      await api.put("/settings/nhp-lock", { enabled: v });
      setEnabled(v);
      toast.success(v ? "Kunci profile NHP diaktifkan" : "Kunci profile NHP dinonaktifkan — agen bebas cetak paket banyak HP");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  if (enabled === null) return null;
  return (
    <Card className="bg-card border-border" data-testid="nhp-lock-settings">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center gap-2">
          {enabled ? <Lock className="w-4 h-4 text-amber-400" /> : <Unlock className="w-4 h-4 text-emerald-400" />} Kunci Profile NHP (Banyak HP)
        </CardTitle>
        <p className="text-xs text-muted-foreground">Jika aktif, agen hanya bisa mencetak voucher paket ≥2 HP untuk pelanggan terdaftar yang sudah disetujui admin (1 set / 30 hari). Jika nonaktif, agen bebas mencetak paket banyak HP tanpa mendaftarkan pelanggan.</p>
      </CardHeader>
      <CardContent className="flex items-center justify-between gap-3 rounded-lg border border-border px-3 py-2.5">
        <div className="text-sm font-semibold" data-testid="nhp-lock-status">{enabled ? "Kunci AKTIF — wajib pelanggan terdaftar" : "Kunci NONAKTIF — agen bebas cetak"}</div>
        <Switch checked={enabled} onCheckedChange={toggle} disabled={saving} data-testid="nhp-lock-switch" />
      </CardContent>
    </Card>
  );
}
